import { globalConfigUrl, splitIoConfig } from "./core/configurations/configuration";
import { GlobalConfigDefinition, createDefaultConfig } from "./core/globalConfig";
import { FeatureFlagsDefinition, FeatureFlagsProvider } from "@dit/ui-configurations/features";
import { IsDevelopment } from "./core/configuration";
import { isNullOrWhitespace } from "./core/utilities/string";

export interface ConfigSplitLocalDefinition {
    features: {
        [featureName: string]: {
            treatment: "on" | "off";
        };
    };
}

const AppConfig = async () => {
    let baseConfig = {};
    let errorStatusCode = "";
    let hasError = false;
    const fetchConfigData = async () => {
        const responseConfig = await fetch(globalConfigUrl, { cache: "no-store" })
            .then(async response => {
                return (await response.json()) as GlobalConfigDefinition;
            })
            .catch((): null => {
                errorStatusCode = IsDevelopment ? `${globalConfigUrl} not found` : "503";
                hasError = true;
                return null;
            });
        if (!responseConfig) {
            return;
        }

        const combinedConfig = createDefaultConfig(responseConfig);
        baseConfig = combinedConfig;
        // if (process.env.NODE_ENV === "development") {
        //     if (IsGlobalConfigLocalMode) {
        if (true) {
            if (true) {
                const responseSplit = await fetch(splitIoConfig, { cache: "no-store" })
                    .then(async response => {
                        return (await response.json()) as ConfigSplitLocalDefinition;
                    })
                    .catch((): null => {
                        errorStatusCode = `${splitIoConfig} not found`;
                        hasError = true;
                        return null;
                    });
                if (!responseSplit) {
                    return;
                }
                const localFeatures: { [key: string]: any } = {};

                Object.keys(responseSplit.features).forEach(featureName => {
                    localFeatures[featureName] = responseSplit.features[featureName]?.treatment;
                });
                // FYI: if you want the remote Feature flags, simply change the mode here, and provide split api key to the configuration
                const features: FeatureFlagsDefinition = {
                    provider: FeatureFlagsProvider.local,
                    local: localFeatures,
                    split: responseConfig.featureFlags.split,
                };
                combinedConfig.featureFlags = features;
                const linkFavicon = document.getElementById("favicon") as HTMLLinkElement;
                linkFavicon.href = !isNullOrWhitespace(combinedConfig.faviconUrl) ? combinedConfig.faviconUrl : "favicon.png";
                baseConfig = combinedConfig;
            }
        }
    };

    await fetchConfigData();

    return { baseConfig, errorStatusCode, hasError };
};

export default AppConfig;
